// multiple add to cart
(function($) {
    $.fn.giftCardAddToCart = function() {
        this.each(function (index, element) {

            let $self            = $(element),
                $inputs          = $('input[type=radio]', $self),
                moneyPrice       = $('.js-money-price', $self),
                $hiddenProductId = $('input[type=hidden][name=id]', $self);

            $inputs.change(function (event) {
                let changePrice = $(event.target).data('price');
                moneyPrice.text(changePrice);
                $hiddenProductId.val($(event.target).val());
            });
        });
    };
})(jQuery);

$(document).ready(function() {
    $('.js-gift-card').giftCardAddToCart();
});
